import React from 'react'
import { Box, Flex } from '@chakra-ui/react'
import IBbreadcrumb from 'components/common/IBbreadcrumb/IBbreadcrumb'
import './Container.css'

interface IContainerProps {
  children: React.ReactNode
}

const Container: React.FC<IContainerProps> = ({ children }) => (
  <Flex
    h='calc(100vh - 96px)'
    flexWrap='wrap'
    position='relative' 
  >
    <Box
      w='76px'
      bg='tertiary.110'
      zIndex='sticky'
    />
    <Box
      id='container'
      padding='42px 42px 0 42px'
      flex='1'
      position='relative'
    >
      <IBbreadcrumb />
      {children}
    </Box>
  </Flex>
)

export default Container
